export default __webpack_public_path__ + "b77a4fb26f14613fc1589b826a72c2b5.svg";